export default __webpack_public_path__ + "99d1de5a402edcaab0bad80fce87fb6e.svg";